
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { payTemplate } from 'src/app/web/interfaces/project/payments/payments';
import { FormatDataTableGlobal, FormatterDolar, FormatterPeso, FormatterPesonNotDecimal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-create-payments',
  templateUrl: './create-payments.component.html',
  styleUrls: ['./create-payments.component.scss']
})
export class CreatePaymentsComponent implements  AfterViewInit, OnDestroy, OnInit  {
  Paymentsform: FormGroup;
  state 
  idProject
  nameproject
  listmonedas = []
  listanex = []
  respuesta:payTemplate 
  listtype : [{id:number,
               name:string}] 
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiServiceProject,
    private errorService:ErrorService
  ) { 
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
      this.state = params['state'];
      this.nameproject = params['name'];
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.Paymentsform = this.fb.group({
    tipo_pago:[''],
    tipo_moneda:[''],
    total:[''],
    anexo:[''],
    });

    this.Paymentsform.controls['total'].disable();
    this.Paymentsform.controls['anexo'].disable();

    this.apiService.getService(`list-project-play-option?id_project=${this.idProject}`).subscribe({
      next: (data) => {
        if (data) {
          this.listmonedas = data['listPlayOption'];
          this.listanex = data['listPlayOptionAnexo'];
          this.listtype = data['listPlayTemplete'];
         
          this.spinner.hide();
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
  }

  transformAmount(event: any){
  
    let onlyNumbers =  event.target.value+"".replace(/[^\d.-]/g, '');

    if(this.Paymentsform.value.tipo_moneda == 1 || this.Paymentsform.value.tipo_moneda == 16){
    
      let info = event.target.value+"";
      info = info.replace('$','')
      info = info.split(".").join('')
      info = info.split(",").join('')
      onlyNumbers = info
      
      onlyNumbers = FormatterPesonNotDecimal().format(onlyNumbers)
    }else{
      let info = event.target.value+"";
      info = info.replace('$','')
      info = info.split(".").join('')
      info = info.split(",").join('.')
      onlyNumbers = info

      
      onlyNumbers = FormatterPeso().format(onlyNumbers)
    }

    if(this.Paymentsform.value.total != onlyNumbers){
      this.Paymentsform.get("total").setValue(onlyNumbers);
    }
  }

  actionSelectType(){

    if(this.Paymentsform.value.tipo_moneda == ""){
      this.Paymentsform.controls['total'].disable();
      this.Paymentsform.controls['anexo'].disable();
      this.Paymentsform.get("total").setValue("");
    }else{
      this.Paymentsform.controls['total'].enable();
      this.Paymentsform.controls['anexo'].enable();
    }

  }

  formSubmit(){
    this.spinner.show()

    let info = this.Paymentsform.value.total+"";
    info = info.replace('$','')
    info = info.split(".").join('')
    let post = {
      templete_id : Number(this.Paymentsform.value.tipo_pago),
      play_option_id : Number(this.Paymentsform.value.tipo_moneda),
      projects_id : Number(this.idProject),
      monto:info
    }
    this.apiService.postService(`project-play-templete` , post).subscribe({
      next: (data) => {
        if (!data.code) {
          this.respuesta = data
          this.router.navigate(['/pdg/project/pay/create/'+this.idProject+ '/'+ data.templete_id + '/' + this.nameproject])
          this.spinner.hide();
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
  }
  ngAfterViewInit(): void {
    
  }

  ngOnDestroy(): void {
    
  }

  rerender(): void {
    
    
  }
}
